import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent, ZoomMediaSelectedEvent } from '@theme/events';

/**
 * A custom element that renders a media gallery.
 *
 * @typedef {object} Refs
 * @property {import('./zoom-dialog').ZoomDialog} [zoomDialogComponent] - The zoom dialog component.
 * @property {import('./slideshow').Slideshow} [slideshow] - The slideshow component.
 * @property {HTMLElement[]} [media] - The media elements.
 *
 * @extends Component<Refs>
 */
export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, {
      signal,
    });
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#controller.abort();
  }

  /**
   * Handles a variant update event by replacing the current media gallery with a new one.
   *
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;

    if (!source) return;
    const newMediaGallery = source.querySelector('media-gallery');

    if (!newMediaGallery) return;

    this.replaceWith(newMediaGallery);
  };

  /**
   * Handles the 'zoom-media:selected' event.
   * @param {ZoomMediaSelectedEvent} event - The zoom-media:selected event.
   */
  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  /**
   * Zooms the media gallery.
   *
   * @param {number} index - The index of the media to zoom.
   * @param {PointerEvent} event - The pointer event.
   */
  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}



document.querySelectorAll(".product-information .image_wheel_swatches input").forEach(function(button) {
    button.addEventListener("click", function() {

        button.closest(".cutom_swatches_rev").querySelectorAll(".image_wheel_swatches").forEach(function(button2) {
          button2.classList.remove('swatche--active');
        });

        button.closest('.image_wheel_swatches').classList.add('swatche--active');
        var media_alt = button.getAttribute('value');
        if(media_alt != null){
            if(button.closest('.product-information').querySelector("#custom-wheel-swatches") != null){
              var swatch_title = button.getAttribute('data-title');
              button.closest('.product-information').querySelector("#custom-wheel-swatches").setAttribute('value',swatch_title);
              button.closest('.product-information').querySelector("[data-swatch-value]").innerHTML = swatch_title;
            }
            document.querySelectorAll(".slideshow-controls__thumbnails .slideshow-controls__thumbnail").forEach(function(thumbnail) {
              if(thumbnail.querySelector('img').getAttribute('alt') != null){
                if(thumbnail.querySelector('img').getAttribute('alt') == media_alt){
                  thumbnail.click();
                }
              }
            });
        }
    });
});


document.querySelectorAll(".colot-swatch-btn").forEach(function(swatch_btn) {
  swatch_btn.addEventListener("click", function() {

    swatch_btn.closest('.custom-color-swatchs').querySelectorAll('.colot-swatch-btn').forEach(function(button2) {
      button2.classList.remove('swatche--active');
    });
    swatch_btn.classList.add('swatche--active');
    var media_alt = swatch_btn.getAttribute('data-title');

    if(media_alt != null){
        swatch_btn.closest('.collection__list').querySelectorAll('slideshow-slide').forEach(function(thumbnail) {
          if(thumbnail.querySelector('img').getAttribute('alt') != null){
            if(thumbnail.querySelector('img').getAttribute('alt') == media_alt){
              var slider_index = thumbnail.getAttribute('data-slider-index');
              thumbnail.closest('slideshow-container').querySelector('.slideshow-controls__dots button[data-slider-index="'+slider_index+'"]').click();
            }
          }
        });
    }

  });
});
